import { render } from "./EventOrganizer.vue?vue&type=template&id=a90fe172&scoped=true"
import script from "./EventOrganizer.vue?vue&type=script&lang=js"
export * from "./EventOrganizer.vue?vue&type=script&lang=js"

import "./EventOrganizer.vue?vue&type=style&index=0&id=a90fe172&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90fe172"]])

export default __exports__